export class Email {
  Recipient: string;
  SiteName: string;
  EmailTemplateData: EmailTemplateData;
  OptIn: boolean;
}
export class EmailTemplateData {
  constructor(productImage: string, productName: string, selectedColorName: string, selectedColorOpacity: string, postalCode: string, country: string, boardImage: string, recommendationText: string, stepByStepUrl: string, materialsUrl: string, calculatorUrl: string, videosUrl: string, firstName: string, lastName: string, whoAreYou: string, projectType: string) {
    this.ProductImage = productImage;
    this.ProductName = productName;
    this.SelectedColorName = selectedColorName;
    this.SelectedColorOpacity = selectedColorOpacity;
    this.PostalCode = postalCode;
    this.Country = country;
    this.BoardImage = boardImage;
    this.RecommendationText = recommendationText;
    this.StepByStepUrl = stepByStepUrl;
    this.MaterialsUrl = materialsUrl;
    this.CalculatorUrl = calculatorUrl;
    this.VideosUrl = videosUrl;
    this.FirstName = firstName;
    this.LastName = lastName;
    this.WhoAreYou = whoAreYou;
    this.WhatAreYouStaining = projectType;
  }
  ProductImage: string;
  ProductName: string;
  SelectedColorName: string;
  SelectedColorOpacity: string;
  PostalCode: string;
  Country: string;
  OptIn: boolean;
  BoardImage: string;
  RecommendationText: string;
  StepByStepUrl: string;
  MaterialsUrl: string;
  CalculatorUrl: string;
  VideosUrl: string;
  FirstName: string;
  LastName: string;
  WhoAreYou: string;
  WhatAreYouStaining: string;
}



// WEBPACK FOOTER //
// ./src/app/models/email.model.ts